module.exports = __webpack_public_path__ + "img/cs6.b25528bd.png";